import API from './config';
import { ReqsComdinheiroAPI } from './reqs_comdinheiro';

export const FundAPI = {
    async createFund(fund) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/create', fund, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateFund(fund) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/funds/update', fund, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async deleteFund(fundId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/funds/delete/' + fundId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllFunds() {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };

        try {

            const response = await API.get('/funds/getAllFunds', config);

            return {
                success: true,
                body: response.data
            };
        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllFundsMainAtts() {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };

        try {

            const response = await API.get('/funds/getAllFundsMainAtts', config);

            return {
                success: true,
                body: response.data
            };
        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsBySearch(search) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.get('/funds/getFundsBySearch?search=' + search, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientFundsBySearch(search, clientId) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            const response = await API.get(`/funds/getClientFundsBySearch?search=${search}&clientId=${clientId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsBySegmentId(segmentId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/funds/getFundsBySegmentId/' + segmentId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsBySearchAndSegmentId(search, segmentId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/funds/getFundsBySearchAndSegmentId?segmentId=${segmentId}&search=${search}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundByCnpj(cnpj) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            // ? Não deveria ser utilizado o método getFundBySearch?
            // TODO [REFACTOR]: Verificar as possibilidades de refatoração
            const response = await API.post('/funds/getFundByCnpj/', { cnpj: cnpj }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsByCnpjs(cnpjs) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {
            // ? Não deveria ser utilizado o método getFundBySearch?
            // TODO [REFACTOR]: Verificar as possibilidades de refatoração
            const response = await API.post('/funds/getFundsByCnpjs/', { cnpjs: cnpjs }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createAsset(asset) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/createAsset', asset, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                error: error.response.data
            };
        }

    },

    async updateAsset(asset) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/funds/updateAsset', asset, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                error: error.response.data
            };
        }

    },

    async deleteAsset(assetId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/funds/deleteAsset/' + assetId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                error: error.response.data
            };
        }

    },

    async getAllClientFunds(clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/funds/listAllClientFunds/' + clientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsClientByPeriodRent(clientId, startDate, endDate, search) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getFundsClientByPeriodRent', {
                client_id: clientId, start_date: startDate, end_date: endDate, search: search
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFullFundsClientByPeriodRent(clientId, month, year, segmentId, search) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getFullFundsClientByPeriodRent', {
                client_id: clientId, month: month, year: year, segment_id: segmentId, search: search
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientsFromFund(fundId, consultingId) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/funds/getAllClientsFromFund?fund_id=' + fundId + '&consulting_id=' + consultingId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getRankingFundsPerClient(consultingId) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/funds/rankingFundsPerClient/' + consultingId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getAllClientAssets(clientId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        if (startDate && endDate) {
            config.params = {
                startDate: startDate,
                endDate: endDate
            };
        }

        try {

            const response = await API.get('/funds/listAllClientAssets/' + clientId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllClientAssetsByRegime(clientId, accountRegimeId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        console.log("ACCOUNT REGIME ID: ", accountRegimeId);

        try {

            const response = await API.post('/funds/listAllClientAssetsByRegime', {
                client_id: clientId,
                account_regime_id: accountRegimeId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundClientAccountList(fundId, clientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getFundClientAccountList', {
                fund_id: fundId,
                client_id: clientId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsByAccountId(accountId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/funds/getFundsByAccountId/' + accountId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAllAssetsByDate(clientId, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientAssetListByDate', {
                client_id: clientId,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAllAssetsByDateAndRegime(clientId, startDate, endDate, accountRegimeId, startDatePeriod) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientAssetListByDateAndRegime', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
                account_regime_id: accountRegimeId,
                start_date_period: startDatePeriod,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAssetsInitPortfolio(clientId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientAssetsInitPortfolio', {
                client_id: clientId,
                month: month,
                year: year,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    //Não é necessário o id do cliente pois a conta já é do cliente
    //É necessário o número da conta pois o accountId pode ser NOT_FOUND
    async getClientAssetByCnpjAndAccountId(cnpj, accountId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientAssetByCnpjAndAccountId', {
                cnpj: cnpj,
                account_id: accountId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientAssetByCnpjAndNumberAccount(cnpj, numberAccount) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientAssetByCnpjAndNumberAccount', {
                cnpj: cnpj,
                number_account: numberAccount,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientBalancesRentByPeriod(clientId, initDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientBalancesRentByPeriod', {
                client_id: clientId,
                init_date: initDate,
                end_date: endDate,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getClientFundsRentsByPeriod(clientId, startDate, endDate, search, segmentId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getClientFundsRentsByPeriod', {
                client_id: clientId,
                start_date: startDate,
                end_date: endDate,
                search: search ? search : '',
                segment_id: segmentId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsInfosByFundIds(arrayFundsIds) {

        console.log('arraFundsIds: ', arrayFundsIds);

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getFundsInfosByFundIds', { arrayFundsIds: arrayFundsIds }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getSettledFundsIdsByFundsIdsAndReferenceDate(arrayFundsIds, referenceDate) {

        console.log('arraFundsIds: ', arrayFundsIds);

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/getSettledFundsIdsByFundsIdsAndReferenceDate', { arrayFundsIds: arrayFundsIds, referenceDate: referenceDate }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateAllFundInfosComdinheiro(month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/updateAllFundInfosComdinheiro', {

                month: month,
                year: year,

            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateInfosCarteiraComdinheiroByCNPJ(cnpj) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/funds/updateInfosCarteiraComdinheiroByCNPJ', {
                cnpj: cnpj
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateFundArticles(fundId, fundArticles) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/funds/updateFundArticles`,
                { fund_id: fundId, fund_articles: fundArticles, },
                config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getSimpleFundById(fundId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/funds/getSimpleFundById`,
                { fund_id: fundId, start_date: startDate, end_date: endDate },
                config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundArticles(fundId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/funds/getArticles?fund_id=${fundId}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFullSimpleDataFundoByFundId(fundId, startDate, endDate) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/funds/getFullSimpleDataFundoByFundId`, {
                fund_id: fundId,
                start_date: startDate,
                end_date: endDate
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getBladeFundLocalDataByFundIdAndMonthAndYear(fundId, month, year) {

        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/funds/getBladeFundLocalDataByFundIdAndMonthAndYear?fund_id=${fundId}&month=${month}&year=${year}`, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async createOrUpdateBladeFundLocalDataByFundIdMonthYear(fundId, month, year, data) {

        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/funds/createOrUpdateBladeFundLocalDataByFundIdMonthYear`, {
                fund_id: fundId,
                month: month,
                year: year,
                data: data
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response.data)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getFundsByInstituitionId(instituitionId) {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };
        try {
            const response = await API.get(`/funds/getFundsByInstituitionId/${instituitionId}`, config);
            return {
                success: true,
                body: response.data
            };
        } catch (error) {
            return {
                success: false,
                body: error.response.data
            };
        }
    },

}

//Implementar quando a integração para o tipo de Xml CADASTRO estiver pronta
// export async function getFundCadastroMensalXml(clientId, mainPeriod) {
//     let config = {
//         headers: {
//             'x-access-token': localStorage.getItem('token'),
//         },
//         responseType: 'text'
//     }

//     console.log("getFundCadastroXml props: ", clientId, mainPeriod)

//     try {

//         const response = await API.get(`/funds/getFundCadastroXml?clientId=${clientId}&month=${month}&year=${year}`, config)

//         return {
//             success: true,
//             body: response.data
//         };

//     } catch (error) {

//         console.log("ERROR: ", error.response.data)

//         return {
//             success: false,
//             body: error.response.data
//         };
//     }

// }

export async function getFundMovimentoMensalXml(clientId, month, year) {
    let config = {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        },
        responseType: 'text'
    }

    try {
        const response = await API.get(`/funds/getFundMovimentoMensalXml?clientId=${clientId}&month=${month}&year=${year}`, config)
        return {
            success: true,
            body: response.data
        };

    } catch (error) {

        console.log("ERROR: ", error.response.data)

        return {
            success: false,
            body: error.response.data
        };
    }

}

export async function getFundMovimentoTrimestralXml(clientId, month, year) {
    let config = {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        },
        responseType: 'text'
    }

    try {
        const response = await API.get(`/funds/getFundMovimentoTrimestralXml?clientId=${clientId}&month=${month}&year=${year}`, config)
        return {
            success: true,
            body: response.data
        };

    } catch (error) {
        console.log("ERROR getFundMovimentoTrimestralXml:", error.response ? error.response.status : error.message);
        console.log("ERROR body:", error.response ? error.response.data : '');
        return {
            success: false,
            body: error.response ? error.response.data : error.message
        };
    }

}

export async function getFundCadastroMensalXml(clientId, month, year) {
    let config = {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        },
        responseType: 'text'
    }

    try {
        const response = await API.get(`/funds/getFundCadastroMensalXml?clientId=${clientId}&month=${month}&year=${year}`, config)
        return {
            success: true,
            body: response.data
        };

    } catch (error) {
        console.log("ERROR: ", error.response.data)
        return {
            success: false,
            body: error.response.data
        };
    }

}

export async function getFundAlteracaoCadastroXml(clientId, month, year) {
    let config = {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        },
        responseType: 'text'
    }

    try {
        const response = await API.get(`/funds/getFundAlteracaoCadastroXml?clientId=${clientId}&month=${month}&year=${year}`, config)
        return {
            success: true,
            body: response.data
        };

    } catch (error) {
        console.log("ERROR: ", error.response.data)
        return {
            success: false,
            body: error.response.data
        };
    }

}

export async function alignAudespCodes(clientId, month, year, xmlContent) {
    let config = {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        }
    }

    try {
        const response = await API.post(`/funds/alignAudespCodes`, {
            clientId,
            month,
            year,
            xmlFile: xmlContent
        }, config)
        return {
            success: true,
            body: response.data
        };

    } catch (error) {
        console.log("ERROR: ", error.response.data)
        return {
            success: false,
            body: error.response.data
        };
    }

}

